import { FONT_FAMILY } from 'styles/typography'

const themeStyles = colors => {
  const styles = {
    DateSelectorContainer: {
      position: 'relative',
      fontFamily: FONT_FAMILY,
      color: colors.black
    },
    datePickerContainer: {
      color: colors.black
    },
    datePicker: {
      color: colors.black,
      background: colors.white,
      border: `1px solid ${colors.silverGray}`
    },
    datePickerIcon: {
      color: colors.primary
    }
  }
  return styles
}

export default themeStyles
